(function () {
  'use strict';

  // Charge a la fois par snippets/card-product.liquid (grilles) et par
  // sections/main-product.liquid (fiche produit) : sur une page qui contient
  // les deux, on ne veut qu un seul jeu d ecouteurs.
  if (window.__orfeoSurvolPastilles) return;
  window.__orfeoSurvolPastilles = true;

  var WIDTHS = [165, 360, 533, 720, 940, 1066];

  function buildSrcset(baseUrl) {
    var parts = [];
    for (var i = 0; i < WIDTHS.length; i++) {
      parts.push(baseUrl + '&width=' + WIDTHS[i] + ' ' + WIDTHS[i] + 'w');
    }
    return parts.join(', ');
  }

  /* ------------------------------------------------------------------
     Nom du coloris au survol.

     L'etiquette est creee a la volee plutot que rendue en Liquid : deux
     gabarits produisent des pastilles (card-product pour les variantes,
     card-color-siblings pour les fiches soeurs) et un troisieme pourrait
     s'ajouter. La poser ici, une fois, evite de la dupliquer et garantit
     qu'aucune grille ne l'oublie.

     Le libelle vient d'aria-label quand il existe : il porte le nom tel
     qu'ecrit par la boutique, accents et casse d'origine (« Gris chiné »).
     L'attribut title, lui, porte la CLE du nuancier CSS — souvent en
     capitales sans accents — et ne sert que de repli.
     ------------------------------------------------------------------ */
  function etiquette(conteneur) {
    var el = conteneur.querySelector('.card-swatches__nom');
    if (!el) {
      el = document.createElement('span');
      el.className = 'card-swatches__nom';
      el.setAttribute('aria-hidden', 'true');
      conteneur.appendChild(el);
    }
    return el;
  }

  function montrerNom(swatch) {
    var conteneur = swatch.closest('.card-swatches');
    if (!conteneur) return;
    var nom = swatch.getAttribute('aria-label') || swatch.getAttribute('title');
    if (!nom) return;
    var el = etiquette(conteneur);
    el.textContent = nom;
    // alignee sur la pastille survolee, comme sur la maquette, mais jamais
    // au-dela du bord droit de la carte
    el.classList.add('is-visible');
    var debord = swatch.offsetLeft + el.offsetWidth - conteneur.offsetWidth;
    el.style.left = Math.max(0, swatch.offsetLeft - Math.max(0, debord)) + 'px';
  }

  function cacherNom(conteneur) {
    var el = conteneur.querySelector('.card-swatches__nom');
    if (el) el.classList.remove('is-visible');
  }

  /* ------------------------------------------------------------- survol */

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (!swatch || !swatch.closest('.card-swatches')) return;

    montrerNom(swatch);

    if (!swatch.dataset.variantImage) return;

    var cardWrapper = swatch.closest('.card-wrapper');
    if (!cardWrapper) return;

    var primaryImg = cardWrapper.querySelector('.media--hover-effect > img');
    if (!primaryImg) return;

    if (!primaryImg.dataset.originalSrc) {
      primaryImg.dataset.originalSrc = primaryImg.getAttribute('src');
      primaryImg.dataset.originalSrcset = primaryImg.getAttribute('srcset');
    }

    var baseUrl = swatch.dataset.variantImage;
    primaryImg.setAttribute('srcset', buildSrcset(baseUrl));
    primaryImg.setAttribute('src', baseUrl + '&width=533');

    cardWrapper.classList.add('swatch-hover-active');
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (!swatch) return;

    var conteneur = swatch.closest('.card-swatches');

    // on passe d'une pastille a l'autre dans la meme rangee : ni l'image ni
    // l'etiquette ne doivent clignoter entre les deux
    var related = e.relatedTarget;
    if (related && related.closest && related.closest('.card-swatches') === conteneur) {
      return;
    }

    if (conteneur) cacherNom(conteneur);

    var cardWrapper = swatch.closest('.card-wrapper');
    if (!cardWrapper) return;

    var primaryImg = cardWrapper.querySelector('.media--hover-effect > img');
    if (!primaryImg || !primaryImg.dataset.originalSrc) return;

    primaryImg.setAttribute('src', primaryImg.dataset.originalSrc);
    primaryImg.setAttribute('srcset', primaryImg.dataset.originalSrcset);

    cardWrapper.classList.remove('swatch-hover-active');
  });
})();
